import { Order } from '@/models/order';

export class State {
    public orders: Array<Order> = new Array<Order>();
    public pageNumber: number = 1;
    public pageSize: number = 25;
    public totalPages: number = 1;
    public total: number = 0;
    public filterStatus: number | string | null = '';
    public from: string | null = null;
    public to: string | null = null;
}
